module.exports = "<div class=\"row\" id=\"row-content-experience\">\r\n    <div class=\"col-12 p-0\">\r\n        <div class=\" pt-5 home-page\" id=\"collections-container-experience\">\r\n        \r\n        </div>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/experience/experience.component.html
// module id = ./src/app/experience/experience.component.html
// module chunks = main